import React, { useState, Component } from 'react';
import axios from 'axios';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import CommonAlert from '../common/Commonalert';

import { BaseUrl } from '../common/config';
import Loader from '../common/loader';

class Forgotpassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loginStatus: "",
      loginMessage: "",
      isLoading: false,
      alertMessage: '',
    };



    this.accountChange = this.accountChange.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.passwordChange = this.passwordChange.bind(this);

  }

  componentDidMount() {

  }


  validateEmail($email) {
    var emailRegex = /^[a-zA-Z0-9.]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,4}/;
    if (!emailRegex.test($email)) {
      return false;
    } else {
      return true;
    }
  }

  accountChange(event) {
    this.setState({
      account: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "", alertPopup:false });
  }

  emailChange(event) {
    this.setState({
      email: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "", alertPopup:false });
  }

  passwordChange(event) {
    this.setState({
      password: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "", alertPopup:false });
  }

  loginOnSubmit = (event) => {
    event.preventDefault();
    this.setState({ alertPopup:false });
   
    var loginDetails = {};
    if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
    }    

    let URL = BaseUrl + "forgotpassword";
    if (this.validateEmail(this.state.email)) {
      let payload = {
        emailaddress: this.state.email.trim(),
      }
      this.setState({ isLoading: true });
      axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
          if (response.data.success === true) {
            //window.location = '/home';
          this.setState({alertPopup: true, alertMessage: 'For demonstration purposes we have disabled the email functionality!'});
          //this.setState({alertPopup: true, alertMessage: 'We have emailed you the password reset link!'});
         
          }
        this.setState({ isLoading: false });
      }).catch((error) => {
        if (error.response.status === 400){
        this.setState({ alertMessage: error.response.data.message, alertPopup:true, isLoading: false });
      }else{

        this.setState({ isLoading: false, alertPopup: false});
      }
        
      })
    }
    else {
      this.setState({ loginStatus: 401, alertPopup: false });
      this.setState({ loginMessage: "Please enter valid Email Address" });
    }

  }

  render() {
    return (
      <>
        {this.state.alertPopup === true && ( <CommonAlert title='Alert' message={this.state.alertMessage}/> )}
    
        <Header />
        { !this.state.isLoading && <main className='main-section'> <div className="login"> 
          <div className="form">
            <form className="login-form" onSubmit={this.loginOnSubmit}>
              <h2>Reset Password</h2>
              <p>Please enter your email address, We'll send you a link to reset your password.</p>
              {(this.state.loginStatus) ? (this.state.loginStatus === 401 ? <p className='err-msg'>{this.state.loginMessage}</p> : "") : ""}
              <input type="text" id="accountEmail" value={this.state.email} placeholder="Email Address" required onChange={this.emailChange} />
              <button type='submit'>Reset Password</button>

            </form>
            {/* <div className='forget-pass-field'>
                            <a className='pass-reset' href=''>Forgot or reset password</a>
        </div>*/}
          </div>
            
          <div className="back-to-cat">
           {!localStorage.getItem("isLoggedIn") && 
                 <a className="back-btn" href="/"><i className="fa fa-arrow-left"></i> Back to Home</a>
       
           }
            {localStorage.getItem("isLoggedIn") && 
              <a className="back-btn" href="/home"><i className="fa fa-arrow-left"></i> Back to Home</a>
            }
          </div>

        </div>
        </main>
        }
        {this.state.isLoading && <main className='main-section'> <Loader propsClassName="load-lag" /> </main>}
        <Footer />
      </>
    )
  }
}

export default Forgotpassword;